module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;
var listService = require('ListService').default;
var size = fontService.getFontSizes();
var fonts = fontService.getFonts();

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Button</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-8\">\r\n        <select name=\"buttonFontFamily\" class=\"style-font\" style=\"width: 100%;\" id=\"buttonFontFamily\">\r\n         \r\n        </select>\r\n    </div>\r\n    <div class=\"col-md-4\" >\r\n        <select name=\"buttonFontSize\" id=\"buttonFontSize\" class=\"style-font\">\r\n            ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n            <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n            ")
    ;  }; 
    ; __append("\r\n            <option></option>\r\n        </select>\r\n    </div>\r\n</div>\r\n")
    ;  if(listService.accountSettings.UseSystemFont === "True"){ 
    ; __append("\r\n    <div class=\"row\">\r\n        <div class=\"col-md-8 subsection\">\r\n            <div>\r\n                <div id=\"main_text_font_family_custom\">\r\n                    <input id=\"customButtonFontFamily\" style=\"margin-bottom:2px;\" name=\"customButtonFontFamily\" type=\"text\" value=\"")
    ; __append(escapeFn( customButtonFontFamily ))
    ; __append("\" ")
    ; __append(escapeFn( customButtonFontFamilyDisabled ))
    ; __append("/>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    ")
    ;  } 
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-8\">\r\n        <input id=\"buttonTextColorPicker\" name=\"buttonTextColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"buttonTextColor\" name=\"buttonTextColor\" type=\"text\" maxlength=\"7\" style=\"width:80px;\" value=\"")
    ; __append(escapeFn( buttonTextColor ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-4\" style=\"text-align: right;\">\r\n        <img id=\"buttonBoldText\" name=\"buttonTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( buttonBoldSelection ))
    ; __append("\" />\r\n        <img id=\"buttonItalicText\" name=\"buttonTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( buttonItalicSelection ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}